import { useEffect } from "react";
import Parse from "parse";
import { useGame } from "../header/GameContext";
import ButtonOnly from "../button/buttonOnly";
import InputText from "../inputText/inputText";
import "./login.css";

/* 🔑 keyCode 생성 */
const generateKeyCode = () =>
  (
    Date.now().toString(36) + Math.random().toString(36).substring(2, 8)
  ).toUpperCase();

function LoginName({ handleName, setHandleName, onFinish }) {
  const {
    setPlayerName,
    setPlayerKeyCode, // ✅ 여기
    pauseTimer,
  } = useGame();

  const isActive = handleName.trim().length > 0;

  useEffect(() => {
    pauseTimer();
  }, [pauseTimer]);

  const handleStart = async () => {
    if (!handleName.trim()) {
      alert("이름(닉네임) 입력해주세요.");
      return;
    }

    const keyCode = generateKeyCode();

    const GameUser = Parse.Object.extend("yit1");
    const user = new GameUser();
    user.set("playerName", handleName);
    user.set("keyCode", keyCode);

    try {
      await user.save();

      /* ✅ 전역 상태 + localStorage */
      setPlayerName(handleName);
      setPlayerKeyCode(keyCode); // ✅ 여기

      onFinish();
    } catch (e) {
      console.error(e);
      alert("로그인 저장 실패");
    }
  };

  return (
    <div id="content">
      <div className="box2">
        <div id="box_con" className="main_box2">
          <div className="main_Bimg"></div>

          <div className="pdLR16">
            <InputText
              textClass="input02 mt16"
              textValue="이름(닉네임) 입력"
              handleName={handleName}
              setHandleName={setHandleName}
            />
            <ButtonOnly
              btnValue="게임시작"
              btnClass={`inputBtn01 mt16 ${isActive ? "active" : ""}`}
              onFinish={handleStart}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginName;
